import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import {ValidatorUtils} from '@shared/utils/validator.utils';
import {StringUtils} from '@shared/utils/string.utils';

@Directive({
  selector: 'input:not([type]):not([numbers]):not([matDatepicker]), input[type=\'text\']'
})
export class NullDefaultValueDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event.target'])
  onEvent(target: HTMLInputElement) {
    if (StringUtils.isEmptyOrWhitespaces(target.value)) {
      ValidatorUtils.setValueWithoutAsyncValidation(this.ngControl.control, null);
    }
  }
}
